import { axiosClient } from "services/axios";

import { AddPrintTemplateValues, GetPrintTemplatesParams } from "../types";

export function getPrintTemplates({
  page = 1,
  pageSize = 1000,
  doc_operation = null,
}: GetPrintTemplatesParams) {
  return axiosClient.get("documents/templates", {
    params: { page, pageSize, doc_operation },
  });
}

export function deletePrintTemplate(params: { template_id: number }) {
  return axiosClient.delete("documents/template", { params });
}

export function addPrintTemplate(data: AddPrintTemplateValues) {
  return axiosClient.post("documents/template", data);
}

/** Принимает DOM FormData или объект с append (совместимо с multipart и пакетом form-data) */
export function addPrintTemplateFile(
  formData: { append(name: string, value: unknown): void }
) {
  return axiosClient.post("documents/template/file", formData);
}
